import { appendUpgradeStateOverlay } from 'sales/upgrade';
import ColorUtils from 'utils/color-utils';

window.companyPage = function () {
    var companyProfile;
    let hasRSICs = false;

    function pageBodyLoad() {
        checkUserStatus();
        setDownloadOverlayCheckIfFinancialFieldEvent();
    }

    // Check user is valid and logged in
    function checkUserStatus() {
        let method, url, input;

        method = "GET";
        url = "../api/user/user_actions.php?action=check_user";

        const checkUserStatusSuccess = function (response) {
            const responseParsed = JSON.parse(response);
            if (responseParsed.logged_in == true) {
                coreFunctions.userguidingSetup(responseParsed);
                userLoggedIn(); // Valid user
                hasRSICs = responseParsed.user_details.premiumFeatures.includes("rsics");
            } else {
                requireLogin();
            }
        }

        const checkUserStatusError = function () {
            // Redirect page back to login
            requireLogin();
        }

        coreFunctions.xhrHelper(method, url, checkUserStatusSuccess, checkUserStatusError, input);
    }

    // Build page
    function userLoggedIn() {
        let companyID = coreFunctions.getQueryVariable("company_id");
        if (companyID) {
            updateScore();
            getCompanyDetails(companyID);
            if (document.getElementById("companyProfile-followCompanyControl")) {
                checkCompanyAlertSubscription(companyID);
            }
        } else {
            companyDetailsLoadError();
        }
    }

    function setDownloadOverlayCheckIfFinancialFieldEvent() {
        document.querySelectorAll('#downloadFields input[name="downloadFields[]"]').forEach(input => {
            input.addEventListener("change", () => {
                if (input.hasAttribute('data-financial-field')) {
                    document.querySelector('#downloadSelection input[name="downloadFields[]"][value="Yearending"]').checked = true;
                }
                if (document.querySelectorAll('#downloadFields input[name="downloadFields[]"][data-financial-field]:checked').length == 0) {
                    document.querySelector('#downloadSelection input[name="downloadFields[]"][value="Yearending"]').checked = false;
                }
            });
        });
    }

    // Data processing complete
    function allDataLoaded(company) {
        //company.addCompanyDetailsToPage().sortCompanyDirectors().addCompanyDirectorsToPage().addCompanyFinancialsToPage().addWebsiteImage();
        company.addCompanyProfileDetailsToPage().addWebsiteImage();
        document.getElementById("main").classList.remove("mainHidden");
    }

    // Error loading company details
    function companyDetailsLoadError() {
        // No score argument, page was loaded externally rather than from a list
        if (getQueryVariable("score") == null) {
            // Update button action to refresh the page
            companyDetailsLoadErrorBack.innerHTML = "Retry";
            companyDetailsLoadErrorBack.addEventListener("click", function (e) {
                location.reload();
            });
        } else {
            // Button will take you back to the list
            companyDetailsLoadErrorBack.addEventListener("click", function (e) {
                navigateBack();
            });
        }
        // Show error overlay
        coreFunctions.showOverlay("errorloadingcompany");
    }

    // If available add score from list to the page
    function updateScore() {
        if (getQueryVariable("score")) {
            scoreElement.innerHTML = "Score: " + getQueryVariable("score");
        }
        // Company page navigated to from the directors page
        else if (getQueryVariable("director_id")) {
            navigateBackButtonText.innerHTML = " Back to person";
        } else if ((/ml_list|explore/).test(document.referrer)) {
            // Show close button if navigated to from a list
            document.getElementById("navigateBackButton").classList.remove("hidden");
        }
    }

    // Get company details
    function getCompanyDetails(companyID) {
        let method, url, input;

        method = "GET";
        url = `../api/company/company_actions.php?action=getcompanydetails&company_number=${companyID}`;

        // Success
        const getCompanyDetailsSuccess = function (response) {
            const responseParsed = JSON.parse(response);
            coreFunctions.checkForDebugMessages(responseParsed);
            processCompanyDetails(responseParsed.companydata);
            updatePageTitle();
        }

        // Error
        const getCompanyDetailsError = function () {
            companyDetailsLoadError();
        }

        coreFunctions.xhrHelper(method, url, getCompanyDetailsSuccess, getCompanyDetailsError, input);
    }

    // Process returned company details
    function processCompanyDetails(companyData) {
        const company = new CompanyProfile(companyData, null);
        companyPage.companyProfile = company;
        allDataLoaded(company);
    }

    function navigateBack() {
        window.close();
    }

    // Show detailed financial fields
    function showDetailedFinancials(element) {
        var financialTable = document.getElementById("financialsTable");
        if (financialTable.classList.contains("extraFinancialFieldsVisible")) {
            financialTable.classList.remove("extraFinancialFieldsVisible");
        } else {
            financialTable.classList.add("extraFinancialFieldsVisible");
        }
    }

    function checkCompanyAlertSubscription(companyID) {
        let method, url, input;
        const self = this;

        event.preventDefault();
        method = "POST";
        url = "../api/alerts/alerts_actions.php?action=check_company_alert_subscription";
        input = new FormData();
        input.append("CompanyNumber", companyID);

        const subscribeCompanyAlertSuccess = function (responseText) {
            const responseParsed = JSON.parse(responseText);
            if (responseParsed && responseParsed == true) {
                document.getElementById("companyProfile-followCompanyControl").checked = true;
                document.querySelector(".listActionsControlHolder .company-alert span[data-follow='subscribe']").classList.add("hidden");
                document.querySelector(".listActionsControlHolder .company-alert span[data-unfollow='subscribed']").classList.remove("hidden");
            } else {
                document.getElementById("companyProfile-followCompanyControl").checked = false;
                document.querySelector(".listActionsControlHolder .company-alert span[data-follow='subscribe']").classList.remove("hidden");
                document.querySelector(".listActionsControlHolder .company-alert span[data-unfollow='subscribed']").classList.add("hidden");
            }
        }

        const subscribeCompanyAlertError = function () {
            // TODO: Show a modal of failed subscription to alert
        }

        coreFunctions.xhrHelper(method, url, subscribeCompanyAlertSuccess, subscribeCompanyAlertError, input);
        return this;
    }

    function toggleCompanyLocationsView(element) {
        const activeView = element.value;
        document.querySelectorAll(".company-locations-view").forEach(element => element.classList.toggle("company-locations-view--visible", element.dataset.view == activeView));
        if (activeView == "map-view") {
            this.companyProfile.resetCompanyLocationsMap();
        }
    }

    class CompanyProfile extends Company {
        companyLocationsMap;
        companyLocationsFeatureGroup;
        occupationsGroupChart;

        constructor(companyData, parent) {
            super(companyData, parent);
            this.historicRtics = new HistoricRtics(companyData.HistoricRTICs ?? []);
        }

        addCompanyProfileDetailsToPage() {
            this.addHeadlineDetailsToCompanyProfile().addPeopleDetailsToCompanyProfile().addFinancialsDetailsToCompanyProfile().addGeneralDetailsToCompanyProfile().addContactDetailsToCompanyProfile().addSectorDetailsToCompanyProfile().addLocationDetailsToCompanyProfile().addGrowthDetailsToCompanyProfile().addJobsAndSkillsDataToCompanyProfile().addEsgDetailsToCompanyProfile();

            return this;

        }

        addJobsAndSkillsDataToCompanyProfile() {
            let dataHolder, jobPostingsBySoc4Holder, jobPostingsByLotHolder, jobPostingsBySkillHolder;
            const jobsDataHolder = document.getElementById("jobsDataHolder");
            const sectionTabJobs = document.getElementById("sectionTabJobs");
            const sectionTab = sectionTabJobs.parentElement;
            const userHasLightcast = sectionTabJobs.getAttribute("data-has-access") == "1";
            document.querySelector(".sectionBlock[data-section='Jobs and skills']").classList.remove("hidden");

            if (!userHasLightcast) {
                // Lightcast: Paid add-on
                sectionTab.classList.add("disabled");
                sectionTab.classList.add("upgrade-required");

                const dummyBlur = document.createElement("div");
                dummyBlur.style.height = "700px";
                dummyBlur.style.backgroundImage = `url(${urlPath}/images/upgrade_blur_company_jobs.webp)`;
                dummyBlur.style.backgroundSize = "contain";
                dummyBlur.style.backgroundRepeat = "no-repeat";
                dummyBlur.style.backgroundPosition = "center top";

                jobsDataHolder.style.position = "relative";
                jobsDataHolder.appendChild(dummyBlur);

                appendUpgradeStateOverlay(jobsDataHolder, null, "lightcast");
                return this;
            }

            if (this.companyJobPostings.companyJobPostingsAvailable()) {
                let fieldContentWrapper = jobsDataHolder.appendChild(coreFunctions.createElementHelper("div", { class: "fieldContentWrapper", "data-name": "jobPostingsOverTimeBySoc4" }));

                jobPostingsBySoc4Holder = this.companyJobPostings.createCompanyJobPostingsElement();
                jobPostingsBySoc4Holder.appendChild(this.createSearchableTable("companyJobPostingsBySOC4", this.companyJobPostings, "companyJobPostingsBySOC4", "companyJobPostingsTableHeadings", "Search job postings..."));
                fieldContentWrapper.appendChild(jobPostingsBySoc4Holder);

                if (this.companyJobPostingsOverTime && this.companyJobPostingsOverTime.CompanyJobPostingsOverTimeBySoc4.length > 0) {
                    if (this.companyJobPostingsOverTime.CompanyJobPostingsOverTimeBySoc4.length > 0) {
                        let jobPostingsOverTimeBySoc4FieldHolder = fieldContentWrapper.appendChild(this.createDataFieldHolder("JobPostingsOverTimeBySoc4", "", null, null))
                        jobPostingsOverTimeBySoc4FieldHolder.querySelector(".fieldDataHolder").appendChild(this.createJobPostingOverTimeChartHolder("jobPostingsOverTimeBySoc4"));
                        this.drawJobPostingOverTimeBarChart("jobPostingsOverTimeBySoc4", this.companyJobPostingsOverTime.CompanyJobPostingsOverTimeBySoc4, "numeric");
                    }
                }

                fieldContentWrapper = jobsDataHolder.appendChild(coreFunctions.createElementHelper("div", { class: "fieldContentWrapper", "data-name": "jobPostingsOverTimeByLot" }));

                if (this.companyJobPostings.companyJobPostingsByLotAvailable()) {
                    jobPostingsByLotHolder = this.companyJobPostings.createCompanyJobPostingsByLotElement();
                    jobPostingsByLotHolder.appendChild(this.createSearchableTable("companyJobPostingsByLot", this.companyJobPostings, "companyJobPostingsByLot", "companyJobPostingsByLotTableHeadings", "Search job postings..."));

                    fieldContentWrapper.appendChild(jobPostingsByLotHolder);
                }

                if (this.companyJobPostingsOverTime && this.companyJobPostingsOverTime.CompanyJobPostingsOverTimeByLot.length > 0) {
                    let jobPostingsOverTimeyLotFieldHolder = fieldContentWrapper.appendChild(this.createDataFieldHolder("JobPostingsOverTimeByLot", "", null, null));
                    jobPostingsOverTimeyLotFieldHolder.querySelector(".fieldDataHolder").appendChild(this.createJobPostingOverTimeChartHolder("jobPostingsOverTimeByLot"));
                    this.drawJobPostingOverTimeBarChart("jobPostingsOverTimeByLot", this.companyJobPostingsOverTime.CompanyJobPostingsOverTimeByLot, "numeric");
                }

                if (this.companyJobPostings.companyJobPostingsBySkillAvailable()) {
                    jobPostingsBySkillHolder = document.getElementById("jobsDataHolder").appendChild(this.companyJobPostings.createCompanyJobPostingsBySkillElement());
                    jobPostingsBySkillHolder.appendChild(this.createSearchableTable("companyJobPostingsBySkill", this.companyJobPostings, "companyJobPostingsBySkill", "companyJobBySkillTableHeadings", "Search job postings..."));
                }
            } else {
                // Not all companies have jobs data
                sectionTab.classList.add("disabled");

                // Reuse the upgrade code, even though it's not to upgrade
                appendUpgradeStateOverlay(jobsDataHolder, null, "insufficient");
            }

            return this;
        }

        addHeadlineDetailsToCompanyProfile() {
            // General fields, check field is available first
            document.getElementById("companiesHouseLink").href = `https://find-and-update.company-information.service.gov.uk/company/${this.companyNumber}`;
            document.getElementById("companiesHouseLink").innerHTML = this.companyNumber;
            const companyNameHolder = document.querySelector(".data-field[field='CompanyName']").appendChild(coreFunctions.createElementHelper("div", { class: "flex-row-holder" }));
            companyNameHolder.appendChild(this.addCompanyIcon());
            companyNameHolder.appendChild(coreFunctions.createElementHelper("span", { innerHTML: this.companyName }));
            // document.querySelector(".data-field[field='CompanyName']").innerHTML = this.isFieldAvailable(this.companyName) ? this.companyName : "Unavailable";
            document.querySelector(".data-field[field='IncorporationDate']").innerHTML = this.isFieldAvailable(this.incorporationDate) ? moment(this.incorporationDate).format("Do  MMMM YYYY") : "Unavailable";
            document.querySelector(".data-field[field='CompanyCategory']").innerHTML = this.isFieldAvailable(this.companyCategory) ? "Company type: " + this.companyCategory : "Company category unavailable";
            document.querySelector(".data-field[field='CompanyStatus']").innerHTML = this.isFieldAvailable(this.companyStatus) ? `Company status: <span class="${this.formatCompanyStatusStyle()}">${this.companyStatus}</span>` : "Company status unavailable";
            if (!this.active) {
                document.getElementById("companyNumberHolder").appendChild(coreFunctions.createElementHelper("div", { class: "data-field", innerHTML: `Last known active date: <span class="orange">${moment(this.lastKnownActiveDate).format("Do  MMMM YYYY")}</span>` }));
            }
            document.querySelector(".data-field[field='Company_description']").innerHTML = this.companyDescription;
            if (this.isFieldAvailable(this.esgStatementUrl)) {
                document.getElementById("esgStatementHolder").classList.remove("hidden");
                document.getElementById("esgStatementLink").href = coreFunctions.formatUrl(this.esgStatementUrl);
            }
            return this;
        }

        addGrowthDetailsToCompanyProfile() {
            const percentFormat = new Intl.NumberFormat('en', { style: 'percent', signDisplay: 'exceptZero', maximumSignificantDigits: 3, minimumSignificantDigits: 2 });
            let growthChartsHolder;
            let dataHolder = coreFunctions.createElementHelper("div", { class: "companyProfileDataHolder", "data-section": "Growth" });

            dataHolder.appendChild(this.createDataFieldHolder("BestEstimateGrowthPercentagePerYear", "Best estimate growth percentage per year<a class='explanationLink' href='https://help.thedatacity.com/knowledge/estimated-turnover-employees' target='_blank'>?</a>", ((this.isFieldAvailable(this.bestEstimateGrowthPercentagePerYear)) ? `<span class="${this.getValueStyleClass(this.bestEstimateGrowthPercentagePerYear)}">${percentFormat.format(this.bestEstimateGrowthPercentagePerYear)}</span>` : "Unavailable"), null));

            const companySizeTooltip = "Our company sizes are based on the UK's legislative definition on company sizes. You can read more about the categorisation <a target='_blank' href='https://help.thedatacity.com/knowledge/company-sizes'>here.</a>";
            dataHolder.appendChild(this.createDataFieldHolder("CompanyGrowthStageEstimate", "Company size estimate", ((this.isFieldAvailable(this.companyGrowthStageEstimate)) ? this.companyGrowthStageEstimate : "Unavailable"), null, companySizeTooltip));

            dataHolder.appendChild(this.createDataFieldHolder("OECDScaleup", "OECD scaleup?", this.oecdScaleup ? "<span data-property='true'>Yes</span>" : "<span data-property='false'>No</span>", null));

            dataHolder.appendChild(this.createDataFieldHolder("InnovationScore", "Innovation score <span class='alphaDataPoint'>(ALPHA)</span>", ((this.isFieldAvailable(this.innovationScore)) ? this.formatInnovationScore() : "Unknown"), null)); // Innovation score

            dataHolder.appendChild(this.createDataFieldHolder("fundingDetails", `Funding<a class="dealroom" href='https://dealroom.co/' target='_blank'><img src='${urlPath}/images/dealroom-logo-white.svg' loading='lazy'/></a>`, ((this.fundingDataAvailable()) ? this.createFundingDetailsContent().outerHTML : "Unavailable"), null));

            // dataHolder.appendChild(this.createDataFieldHolder("Spinout", "Company is University spinout?", (this.isFieldAvailable(this.dealroomIsSpinout)) ? ((this.dealroomIsSpinout == true) ? "<span data-property='true'>Yes</span>" : "<span data-property='false'>No</span>") : "Unknown", null));

            dataHolder.appendChild(this.createDataFieldHolder("FundingYears3", `Funding received in last 3 years?<a class='dealroom' href='https://dealroom.co/' target='_blank'><img src='${urlPath}/images/dealroom-logo-white.svg' loading='lazy'/></a>`, this.checkDealroomFundingInPeriod(moment().subtract(3, "years")) ? "<span data-property='true'>Yes</span>" : "<span data-property='false'>No</span>", null));

            dataHolder.appendChild(this.createDataFieldHolder("InnovateUkYears3", "Innovate UK grant received in last 3 years?", (this.innovateUkFunding.checkEventInPeriod(moment().subtract(3, "years"))) ? "<span data-property='true'>Yes</span>" : "<span data-property='false'>No</span>", null));

            dataHolder.appendChild(this.createDataFieldHolder("_360GivingYears1", "Grant reported by 360 Giving in last 3 years?", (this._360GivingFunding
                .checkEventInPeriod(moment().subtract(3, "years"))) ? "<span data-property='true'>Yes</span>" : "<span data-property='false'>No</span>", null));

            document.getElementById("growthDataHolder").appendChild(dataHolder);

            growthChartsHolder = document.getElementById("growthDataHolder").appendChild(coreFunctions.createElementHelper("div", { class: "growthChartsHolder" }));

            if (this.isFieldAvailable(this.employmentEstimates)) {
                let employeeEstimatesFieldHolder = growthChartsHolder.appendChild(this.createDataFieldHolder("EmploymentEstimates", "Employment estimates", null, null))
                employeeEstimatesFieldHolder.querySelector(".fieldDataHolder").appendChild(this.createGrowthLineChartHolder("employmentEstimates"));
                this.drawGrowthLineChart("employmentEstimates", this.employmentEstimates, "numeric");
            }

            if (this.isFieldAvailable(this.turnoverEstimates)) {
                let turnoverEstimatesFieldHolder = growthChartsHolder.appendChild(this.createDataFieldHolder("TurnoverEstimates", "Turnover estimates", null, null))
                turnoverEstimatesFieldHolder.querySelector(".fieldDataHolder").appendChild(this.createGrowthLineChartHolder("turnoverEstimates"));
                this.drawGrowthLineChart("turnoverEstimates", this.turnoverEstimates, "currency");
            }

            if (this.perRoundFundingAvailable()) {
                document.getElementById("growthDataHolder").appendChild(this.createPerRoundFundingElement());
            }

            if (this._360GivingFunding.grantFundingAvailable()) {
                const _360GivingTooltip = `<p>360Giving uses a wide variety of datasets to help funders publish open data about who, what and where they fund, using the 360Giving Data Standard. These datasets have been curated into a search-engine for grants data.</p><p>You can read more ${this.formatTooltipLink("https://help.thedatacity.com/knowledge/360giving-data", "here", "_blank")}.</p>`;
                document.getElementById("growthDataHolder").appendChild(this.createDataFieldHolder("_360GivingFunding", "<a href='https://grantnav.threesixtygiving.org/' target='_blank'>360 Giving funding grants</a>", null, null, _360GivingTooltip)).appendChild(this.createExpandableTable(this._360GivingFunding));
            }

            if (this.innovateUkFunding.innovateUkFundingGrantsAvailable()) {
                const innovateUkTooltip = `<p>Innovate UK funding brings together a series of grants that support innovation and research, and sit within UK Research and Innovation (UKRI)'s umbrella. They publish open data on successful grants from 2004.</p><p>You can read more ${this.formatTooltipLink("https://help.thedatacity.com/knowledge/innovate-uk-data", "here", "_blank")}.</p>`;
                document.getElementById("growthDataHolder").appendChild(this.createDataFieldHolder("innovateUkFunding", "Innovate UK funding grants", null, null, innovateUkTooltip)).appendChild(this.createExpandableTable(this.innovateUkFunding));
            }

            return this;
        }

        addPeopleDetailsToCompanyProfile() {
            let dataHolder = coreFunctions.createElementHelper("div", { class: "companyProfileDataHolder", "data-section": "People" });

            const bestEstimateEmployeesTooltip = "<p>We use our company growth rates to estimate employees and to estimate turnover.</p><p>Read more <a target='_blank' href='https://help.thedatacity.com/knowledge/estimated-turnover-employees-growth'>here</a></p>";

            dataHolder.appendChild(this.createDataFieldHolder("BestEstimateEmployees", `Estimated employee count`, ((this.isFieldAvailable(this.bestEstimateEmployees)) ? `<span class="estimate">${this.bestEstimateEmployees.toLocaleString()}</span>` : "Unknown"), null, bestEstimateEmployeesTooltip)); // Estimated employees
            // dataHolder.appendChild(this.createDataFieldHolder("BestEstimateEmployeeGrowthPercentagePerYear", "Best estimate employee growth percentage per year", `${(this.bestEstimateEmployeeGrowthPercentagePerYear != undefined) ? `<span class='${(this.bestEstimateEmployeeGrowthPercentagePerYear < 0) ? 'negativePercentage' : 'positivePercentage'}'>${(this.bestEstimateEmployeeGrowthPercentagePerYear * 100).toFixed(1)}%</span>` : 'Unknown'}`, null)); // Employee growth
            document.getElementById("peopleDataHolder").appendChild(dataHolder);

            if (this.womenLedStats) {
                document.getElementById("peopleDataHolder").appendChild(this.createWomenLedStatsElment());
            }

            if (this.directorsAvailable()) {
                document.getElementById("peopleDataHolder").appendChild(this.createDataFieldHolder("Directors", "Directors", this.createDirectorsHolder().outerHTML, null)); // Directors
            }
            // Add people with significant control if available
            if (this.personsWithSignificantControl.personsWithSignificantControlAvailable()) {
                document.getElementById("peopleDataHolder").appendChild(this.personsWithSignificantControl.createPersonsWithSignificantControlElement())
            }
            // Add shareholder details if available
            if (this.shareHolders.shareHoldersAvailable()) {
                document.getElementById("peopleDataHolder").appendChild(this.createDataFieldHolder("shareHolders", "Shareholders", null, null)).appendChild(this.createExpandableTable(this.shareHolders));
            }
            return this;
        }

        createWomenLedStatsElment() {
            let womenLedStatsHolder, womenLedStatsDataHolder;
            const womenFoundersLink = "<p>Find out more <a href='https://help.thedatacity.com/knowledge/gender-data' target='_blank'>here</a>.</p>"
            let womenFoundersTooltip = `<p>The number of women founders compared to the total number of founders.</p><p>Founders are named directors that have been with the company since an early stage and are nominated as persons of significant control; they likely have shares or voting rights in the company. Leaders and founders are separate. A leader is more simply a company director or officer that is named on Companies House.</p>${womenFoundersLink}`;
            let womenOfficersTooltip = `<p>The number of active women officers compared to the total number of active officers.</p>${womenFoundersLink}`;
            let womenLedTooltip = `<p>If the majority of active company officers are women, this is a women led business.</p>${womenFoundersLink}`;

            womenLedStatsHolder = document.createDocumentFragment();
            womenLedStatsHolder.appendChild(coreFunctions.createElementHelper("h4", { innerHTML: "Woman led statistics", class: "subdata-heading" }));
            womenLedStatsDataHolder = womenLedStatsHolder.appendChild(coreFunctions.createElementHelper("div", { class: "companyProfileDataHolder", "data-section": "womenLedStats" }));
            womenLedStatsDataHolder.appendChild(this.createDataFieldHolder("ActiveFemaleFounders", "Women founders", `${(this.womenLedStats.ActiveFemaleFounders != undefined) ? `${this.womenLedStats.ActiveFemaleFounders}  <span class="data-description">/ ${this.getTotalFounders()}</span>` : 'Unknown'}`, null, womenFoundersTooltip)); // Total female founders
            womenLedStatsDataHolder.appendChild(this.createDataFieldHolder("ActiveFemaleDirectors", "Women officers", `${(this.womenLedStats.ActiveFemaleDirectors != undefined) ? `${this.womenLedStats.ActiveFemaleDirectors} <span class="data-description">/ ${this.womenLedStats.TotalActiveDirectors}</span>` : 'Unknown'}`, null, womenOfficersTooltip)); // Total female directors

            womenLedStatsDataHolder.appendChild(this.createDataFieldHolder("femaleLedBusiness", "Women led business?", this.isFemaleLedBusiness() ? "<span data-property='true'>Yes</span>" : "<span data-property='false'>No</span>", null, womenLedTooltip)); // Female led business
            return womenLedStatsHolder;

        }

        isFemaleLedBusiness() {
            return (this.womenLedStats && this.womenLedStats.ActiveFemaleDirectors && (this.womenLedStats.ActiveFemaleDirectors >= this.womenLedStats.ActiveMaleDirectors));
        }

        getTotalFounders() {
            if (this.womenLedStats.TotalActiveFounders) {
                return this.womenLedStats.TotalActiveFounders;
            } else {
                return this.womenLedStats.ActiveFemaleFounders + this.womenLedStats.ActiveMaleFounders;
            }
        }

        addFinancialsDetailsToCompanyProfile() {
            let dataHolder = coreFunctions.createElementHelper("div", { class: "companyProfileDataHolder", "data-section": "Financials" });
            const currencyFormat = new Intl.NumberFormat('en-EN', { style: 'currency', maximumFractionDigits: 0, currency: 'GBP' });

            const bestEstimateTurnoverTooltip = "<p>We use our company growth rates to estimate employees and to estimate turnover.</p><p>Read more <a target='_blank' href='https://help.thedatacity.com/knowledge/estimated-turnover-employees-growth'>here</a></p>";

            dataHolder.appendChild(this.createDataFieldHolder("BestEstimateTurnover", `Estimated turnover`, ((this.isFieldAvailable(this.bestEstimateTurnover)) ? `<span class="estimate">${currencyFormat.format(this.bestEstimateTurnover)}</span>` : "Unknown"), null, bestEstimateTurnoverTooltip)); // Estimated turnover
            // dataHolder.appendChild(this.createDataFieldHolder("BestEstimateTurnoverGrowthPercentagePerYear", "Best estimate turnover growth percentage per year", `${(this.bestEstimateTurnoverGrowthPercentagePerYear != undefined) ? `<span class='${(this.bestEstimateTurnoverGrowthPercentagePerYear < 0) ? 'negativePercentage' : 'positivePercentage'}'>${(this.bestEstimateTurnoverGrowthPercentagePerYear * 100).toFixed(1)}%</span>` : 'Unknown'}`, null)); // Turnover growth
            dataHolder.appendChild(this.createDataFieldHolder("EstimatedGVA", "Estimated gross value added (GVA)", ((this.isFieldAvailable(this.estimatedGVA)) ? currencyFormat.format(this.estimatedGVA) : "Unknown"), null, "<p>We have produced an estimated GVA measure at the company level using official GVA and employment data.</p><p>You can read more <a target='_blank' href='https://help.thedatacity.com/knowledge/gva-data'>here</a>.</p>"));  // Estimated GVA
            document.getElementById("financialsDataHolder").appendChild(dataHolder);
            document.getElementById("financialsDataHolder").appendChild(this.addCompanyFinancialsToElement());

            return this;
        }

        addGeneralDetailsToCompanyProfile() {
            let dataHolder = coreFunctions.createElementHelper("div", { class: "companyProfileDataHolder", "data-section": "General" });
            //const similarCompaniesTooltip = `<p>Our process evaluates the web text of the more than 1.6 million companies in our database to assess each company's likeness with each other.</p><p>You can read more ${this.formatTooltipLink("https://help.thedatacity.com/knowledge/similar-companies", "here", "_blank")}.</p>`

            if (this.groupStructureAvailable()) {
                dataHolder.appendChild(this.createDataFieldHolder("groupStructure", "Group structure", this.createGroupStructureDetailsContent(), null));
            }

            const innovationScoreTooltip = `<p>Our proprietary Innovation Score is generated using ML trained on available R&D spend data. The model predicts whether a company is Innovative or Not Innovative, based on evidence of innovativeness in the company's webtext. The final score reflects our confidence in this prediction (3 being most confident).</p><p>Find out more ${this.formatTooltipLink("https://help.thedatacity.com/knowledge/innovation-score", "here", "_blank")}.</p>`;

            dataHolder.appendChild(this.createDataFieldHolder("InnovationScore", "Innovation score <span class='alphaDataPoint'>(ALPHA)</span>", ((this.isFieldAvailable(this.innovationScore)) ? this.formatInnovationScore() : "Unknown"), null, innovationScoreTooltip)); // Innovation score
            // dataHolder.appendChild(this.createDataFieldHolder("SimilarCompanies", "Similar companies <span class='alphaDataPoint'>(ALPHA)</span>", ((this.isFieldAvailable(this.similarCompanies)) ? this.formatSimilarCompanies() : "Unknown"), null, similarCompaniesTooltip));  // Similar company
            dataHolder.appendChild(this.createDataFieldHolder("TonnesOfC02equivGHGPerYear", "Estimated greenhouse gas emissions (tonnes of CO<sub>2</sub> equivalent per year)", ((this.isFieldAvailable(this.tonnesOfC02equivGHGPerYear)) ? this.tonnesOfC02equivGHGPerYear.toLocaleString() : "Unknown"), null, "<p>We estimate greenhouse gas emissions based on a <a href='https://www.gov.uk/government/statistics/final-uk-greenhouse-gas-emissions-national-statistics-1990-to-2020' target='_blank'>published table</a> of total carbon emissions by SIC sector.</p><p>We assume that carbon emissions are spread equally across all companies within the SIC sector in proportion to their number of employees.</p><p>Therefore, we only hold an estimate for a limited number of companies.</p><p><a href='https://help.thedatacity.com/knowledge/how-do-you-get-green-house-emissions-data' target='_blank'>Find out more</a></p>")); // Greenhouse gas emissions

            dataHolder.appendChild(this.createDataFieldHolder("SectorKeywords", "Sector keywords", ((this.isFieldAvailable(this.sectorKeywords)) ? this.sectorKeywords.join(", ") : "Unavailable"), null)); // sector keywords
            dataHolder.appendChild(this.createDataFieldHolder("InnovationKeywords", "Innovation keywords", ((this.isFieldAvailable(this.innovationKeywords)) ? this.innovationKeywords.join(", ") : "Unavailable"), null)); // innovation keywords

            document.getElementById("generalDataHolder").appendChild(dataHolder);

            const companyTradeHeader = "<thead><tr><th>HS6 code</th><th>Description</th><th>Last traded</th></tr></thead>";

            let companyImportsHolder = document.createDocumentFragment();
            companyImportsHolder.appendChild(coreFunctions.createElementHelper("h3", { innerHTML: "Company Imports", class: "subdata-heading-company-imports" }));

            if (this.isFieldAvailable(this.companyImports)) {
                companyImportsHolder.appendChild(coreFunctions.createElementHelper("select", { class: "commodities-select", id: "companyImportsSelect" }));
                companyImportsHolder.appendChild(this.createDataFieldHolder("CompanyImports", "", ((this.isFieldAvailable(this.companyImports)) ? '<table class="financialDetailsTable">' + companyTradeHeader + '<tbody data-field="CompanyImports">' + this.companyImports.sort((a, b) => b.LastTradeDate.localeCompare(a.LastTradeDate)).map(({ HS6, LastTradeDate }) => `<tr data-code="${HS6}"><td><a href="https://www.uktradeinfo.com/commodities/${HS6}" target="_blank" rel="noopener">${HS6}</a></td><td class="companyExportDescription">${(this.formatTradeDataCodeDescription(HS6))}</td><td>${moment(LastTradeDate).format("MMM YYYY")}</td>`).join("</tr>") + "</tbody></table>" : "Unavailable"), null));

                document.getElementById("generalDataHolder").appendChild(companyImportsHolder);
                this.createTradeDataTomSelectSearch("companyImportsSelect", this.companyImports, "CompanyImports");
            } else {
                companyImportsHolder.appendChild(this.createDataFieldHolder("CompanyImports", "", "Unavailable", null));
                document.getElementById("generalDataHolder").appendChild(companyImportsHolder);
            }

            let companyExportsHolder = document.createDocumentFragment();
            companyExportsHolder.appendChild(coreFunctions.createElementHelper("h3", { innerHTML: "Company Exports", class: "subdata-heading-company-exports" }));

            if (this.isFieldAvailable(this.companyExports)) {
                companyExportsHolder.appendChild(coreFunctions.createElementHelper("select", { class: "commodities-select", id: "companyExportsSelect" }));
                companyExportsHolder.appendChild(this.createDataFieldHolder("CompanyExports", "", ((this.isFieldAvailable(this.companyExports)) ? '<table class="financialDetailsTable">' + companyTradeHeader + '<tbody data-field="CompanyExports">' + this.companyExports.sort((a, b) => b.LastTradeDate.localeCompare(a.LastTradeDate)).map(({ HS6, LastTradeDate
                }) => `<tr data-code="${HS6}"><td><a href="https://www.uktradeinfo.com/commodities/${HS6}" target="_blank" rel="noopener">${HS6}</a></td><td class="companyExportDescription">${(this.formatTradeDataCodeDescription(HS6))}</td><td>${moment(LastTradeDate).format("MMM YYYY")}</td>`).join("</tr><tr>") + "</tbody></table>" : "Unavailable"), null));

                document.getElementById("generalDataHolder").appendChild(companyExportsHolder);
                this.createTradeDataTomSelectSearch("companyExportsSelect", this.companyExports, "CompanyExports");
            } else {
                companyExportsHolder.appendChild(this.createDataFieldHolder("CompanyExports", "", "Unavailable", null));
                document.getElementById("generalDataHolder").appendChild(companyExportsHolder);
            }

            return this;
        }

        addContactDetailsToCompanyProfile() {
            const self = this;
            document.querySelector(".data-field[field='Homepage_domain']").innerHTML = this.isFieldAvailable(this.companyURL) ? `<a target="_blank" href="${coreFunctions.formatUrl(this.companyURL)}">${this.companyURL}</a>` : "Unavailable";
            document.querySelector(".data-field[field='Homepage_domain']").appendChild(this.addMismatchedUrlReportControl()); // Add control to report mismatched URL
            document.querySelector(".data-field[field='Email']").innerHTML = (this.isFieldAvailable(this.emailAddresses)) ? this.emailAddresses.reduce(function (html, email) { html += `<a href="mailto:${email}">${email}</a>${self.addEmailMatchElement(email)}<br>`; return html; }, '') : "Unknown";
            document.querySelector(".data-field[field='RegisteredAddress']").innerHTML = this.isFieldAvailable(this.registeredAddress) ? this.formatRegisteredAddress() : "Unavailable";
            document.querySelector(".data-field[field='Phone']").innerHTML = this.isFieldAvailable(this.phoneNumbers) ? this.phoneNumbers.reduce(function (html, phone) { html += `<a href="tel:${phone}">${phone}</a><br>`; return html; }, '') : "Unavailable";
            document.querySelector(".data-field[field='Social']").innerHTML = this.formatSocialDetails();
            return this;
        }

        // Formats effect of missing fields in concatenated address (e.g. ", 4 Town Street, , Leeds" -> "4 Town Street, Leeds")
        formatRegisteredAddress() {
            return this.registeredAddress.replace(/^, /, "").replace(/(, ?)\1+/g, ", ");
        }

        addSectorDetailsToCompanyProfile() {
            let dataHolder = coreFunctions.createElementHelper("div", { class: "company-details-flex wrap", "data-section": "Sectors" });
            dataHolder.appendChild(this.createDataFieldHolder("SICLUs", "SIC sectors", ((this.isFieldAvailable(this.sics)) ? this.formatSicField(this.sichlus) : "Unavailable"), null)); // SICHLUs
            dataHolder.appendChild(this.createDataFieldHolder("SICs", "SICs", ((this.isFieldAvailable(this.sics)) ? this.formatSicField(this.sics) : "Unavailable"), null)); // SICs

            // RSICs (paid add-on)
            if (hasRSICs) {
                dataHolder.appendChild(this.createDataFieldHolder("RSICs", `RSICs${this.checkRsicsCertification()}`, (this.isFieldAvailable(this.rsics) ? this.formatSicField(this.rsics.map(el => el.sicCode)) : "Unavailable"), null)); // RSICs
            } else {
                const placeholder = document.createElement("div");
                placeholder.classList.add("fieldHolder");
                this.rsics = [""]; // In order for checkRsicsCertification to return checkmark
                placeholder.innerHTML = `<h4>RSICs${this.checkRsicsCertification()}</h4>`;
                dataHolder.appendChild(placeholder);
                const blurredData = [
                    "58420: Lorem Ipsum not supposed to see this text",
                    "25682: Data City premium feature an requires upgrade addon",
                    "67952: Financial procedure required",
                    "12597: Other professionals use this feature for their activities n.e.c.",
                ];
                appendUpgradeStateOverlay(placeholder, blurredData, "rsics");
            }

            document.getElementById("sectorsDataHolder").appendChild(dataHolder);

            if (this.isFieldAvailable(this.rtics) && this.rtics.length > 0) {
                dataHolder.appendChild(this.createDataFieldHolder("RTICs", "RTICs", this.addCompanyRticsToPage(), null)); // RTICs
            }

            if (this.isFieldAvailable(this.cics)) {
                dataHolder.appendChild(this.createDataFieldHolder("CICs", "CICs", this.addCompanyRticsToPage(true), null));
            }

            if (this.isFieldAvailable(this.industrialStrategySectors)) {
                dataHolder.appendChild(this.createDataFieldHolder("industrialStrategySectors", "Industrial strategy sectors", this.industrialStrategySectors.reduce((acc, element) => { acc += element.formatIndustrialStrategySectorDetails(); return acc }, ''))); // Format industrial strategy sectors
            }
            if (this.historicRtics.companyHasHistoricRtics()) {
                const historicRticsHolder = dataHolder.appendChild(this.createDataFieldHolder("HistoricRTICs", "Historic RTICs", "", null));
                this.historicRtics.createHistoricRticsChart(historicRticsHolder.querySelector(".fieldDataHolder"));
            }
            return this;
        }

        addLocationDetailsToCompanyProfile() {
            const locationsAvailable = this.isFieldAvailable(this.locations);

            if (locationsAvailable) {

                const hasLocationWithOccupationCounts = this.locations.find(el => el.occupationCounts.countsAvailable()) != undefined;
                let locationFields;
                if (hasLocationWithOccupationCounts) {
                    locationFields = {
                        postcodeWithSpaces: "Postcode",
                        laName: "Local authority"
                    }
                } else {
                    locationFields = {
                        postcodeWithSpaces: "Postcode",
                        oecdfuaCorePlusCommuting: "OECD city",
                        laName: "Local authority",
                        constituency: "Constituency",
                        nuts1Name: "ITL1 region"
                    };
                }

                const occupationFields = {
                    occupationCounts: "Est. total employee count",
                    STEM: "Est. STEM count",
                    BusinessServices: "Est. Business services count",
                    SHAPE: "Est SHAPE count",
                    Trades: "Est. Trades count",
                    Military: "Est Military count",
                    breakdown: ""
                }

                const dataHolder = coreFunctions.createElementHelper("div", { class: "companyProfileDataHolder company-locations-view company-locations-view--visible", "data-view": "list-view", "data-section": "Locations" });
                const table = dataHolder.appendChild(coreFunctions.createElementHelper("table", { id: "locationDetailsTable", class: "locations-table" }));
                const tableHead = table.appendChild(coreFunctions.createElementHelper("thead", { class: "locations-table__table-head" }));
                const tableHeadRow = tableHead.appendChild(coreFunctions.createElementHelper("tr", { class: "locations-table__table-row" }));
                tableHeadRow.appendChild(coreFunctions.createElementHelper("th", { innerHTML: "Territory", class: "locations-table__table-header", "data-field": "location" }));
                Object.entries(locationFields).forEach(element => tableHeadRow.appendChild(this.createLocationDetailsTableHeader({ field: element[0], content: element[1] })));

                const sectorViewHolder = document.getElementById("locationDataHolder").appendChild(coreFunctions.createElementHelper("div", { class: "company-locations-view", "data-view": "sector-view", "data-section": "Locations" }));

                let locationWithOccupationCounts;
                // Occupation counts are available for at least some locations
                if (locationWithOccupationCounts = this.locations.find(el => el.occupationCounts.countsAvailable())) {
                    Object.entries(occupationFields).forEach(element => tableHeadRow.appendChild(this.createLocationDetailsTableHeader({ field: element[0], content: element[1], occupationField: true })));

                    document.getElementById("locationsKeyHolder").appendChild(locationWithOccupationCounts.occupationCounts.createOccupationCountsKey());


                    sectorViewHolder.appendChild(this.createOccupationGroupsChartLocationSelect());
                    const occupationGroupsChartCanvas = sectorViewHolder.appendChild(coreFunctions.createElementHelper("canvas", { id: "occupationGroupsChartCanvas", class: "occupation-group-locations__chart-canvas" }));
                    this.createOccupationGroupsChart({ canvas: occupationGroupsChartCanvas, field: "laName", topLocationsToShowCount: 5 });
                }
                // No occupation counts available
                else {
                    this.disableLocationsSectorView();
                }

                const ukLocationsTableBody = table.appendChild(coreFunctions.createElementHelper("tbody", { class: "locations-table__table-body locations-table__table-body--uk" }));
                const locationFieldKeys = Object.keys(locationFields);

                this.locations.forEach(location => ukLocationsTableBody.appendChild(location.createLocationsTableRow(locationFieldKeys)));

                if (this.occupationCountByNation && Object.hasOwn(this.occupationCountByNation, "ROW")) {
                    table.appendChild(this.occupationCountByNation.ROW.createLocationsTableContent(locationFieldKeys));
                }
                document.getElementById("locationDataHolder").appendChild(dataHolder);
            }

            return this;
        }

        createLocationDetailsTableHeader({ field, content, occupationField = false } = {}) {
            const th = coreFunctions.createElementHelper("th", { class: "locations-table__table-header", "data-field": field, "data-field_type": (occupationField) ? "occupation-group" : "location" });
            const headerFlex = th.appendChild(coreFunctions.createElementHelper("div", { class: "locations-table__table-header-flex" }));
            if (content) {
                const label = headerFlex.appendChild(coreFunctions.createElementHelper("span", { class: "locations-table__table-header-label", innerHTML: content }));
                const sort = headerFlex.appendChild(coreFunctions.createElementHelper("button", { class: "secondary-button locations-table__table-sort", "data-field": field }, { click: (event) => this.locationDetailsTableSortButtonClick(event.target) }));
                if (occupationField) {
                    th.classList.add("locations-table__table-header--numeric");
                    sort.dataset.occupation_group = true;
                }
            }
            return th;
        }

        disableLocationsSectorView() {
            document.getElementById("radioGroupLocationsSectorView").disabled = true;
            const label = document.getElementById("radioGroupLocationsSectorView").nextElementSibling;
            label.dataset.tooltip = "⚠ A breakdown of occupations is unavailable for this company.";
            label.dataset.tooltip_width = "150px";
            label.style.setProperty('--tooltip-width', '150px');
            label.dataset.tooltip_position = "right";
        }

        locationDetailsTableSortButtonClick(element) {
            const field = element.dataset.field;
            const order = !element.dataset.order ? (element.dataset.occupation_group ? "desc" : "asc") : (element.dataset.order == "desc" ? "asc" : "desc");
            this.updateSortButtonOrder(element, order);

            const sortedLocations = element.dataset.occupation_group ? this.sortLocationsByByOccupationGroup(field, order) : this.sortLocationsByGeography(field, order);

            this.updateLocationDetailsTableBody(sortedLocations);

            return this;
        }

        updateLocationDetailsTableBody(locations) {
            const holder = document.getElementById("locationDetailsTable").querySelector(".locations-table__table-body--uk");
            const locationFieldKeys = Array.from(document.getElementById("locationDetailsTable").querySelectorAll('.locations-table__table-header[data-field_type="location"]')).map(el => el.dataset.field);
            coreFunctions.clearElementChildren(holder);
            locations.forEach(location => holder.appendChild(location.createLocationsTableRow(locationFieldKeys)));
            return this;
        }

        updateSortButtonOrder(element, order) {
            let activeSortingElement;
            if (activeSortingElement = document.getElementById("locationDetailsTable").querySelector(".locations-table__table-sort--asc, .locations-table__table-sort--desc")) {
                activeSortingElement.classList.remove("locations-table__table-sort--asc", "locations-table__table-sort--desc");
            }
            element.classList.toggle("locations-table__table-sort--asc", order == "asc");
            element.classList.toggle("locations-table__table-sort--desc", order == "desc");
            element.dataset.order = order;
        }

        sortLocationsByGeography(field, order) {
            const multiplier = order == "asc" ? 1 : -1;
            return this.locations.sort((a, b) => a[field].localeCompare(b[field]) * multiplier);
        }

        sortLocationsByByOccupationGroup(field, order) {
            const multiplier = order == "asc" ? 1 : -1;
            return this.locations.sort((a, b) => {
                const aOC = a.occupationCounts.getOccupationCountByField(field) ?? -Infinity;
                const bOC = b.occupationCounts.getOccupationCountByField(field) ?? -Infinity;
                return (aOC - bOC) * multiplier;
            });
        }

        createOccupationGroupsChartLocationSelect() {
            const holder = coreFunctions.createElementHelper("div", { class: "occupation-group-locations__select-holder" });

            holder.appendChild(coreFunctions.createElementHelper("label", { for: "occupationGroupsGeographySelect", innerHTML: "Pick geography: " }));
            const select = holder.appendChild(coreFunctions.createElementHelper("select", { id: "occupationGroupsGeographySelect", name: "occupation-group-geography", class: "occupation-group-locations__select" }, { change: (event) => this.createOccupationGroupsChart({ canvas: document.querySelector(".occupation-group-locations__chart-canvas"), field: event.target.value, topLocationsToShowCount: 5 }) }));
            const defaultOption = "laName";
            const locations = {
                oecdfuaCorePlusCommuting: "OECD city",
                laName: "Local authority",
                constituency: "Constituency",
                nuts1Name: "ITL1 region"
            }
            Object.entries(locations).forEach(location => {
                const option = select.appendChild(coreFunctions.createElementHelper("option", { innerHTML: location[1], value: location[0] }));
                option.selected = location[0] == defaultOption;
            });
            return holder;
        }

        createOccupationGroupsChart({ canvas, field, topLocationsToShowCount }) {
            const occupationCountsByLocation = this.getOccupationCountsByLocation({ field: field, topLocationsToShowCount: topLocationsToShowCount });
            const cs = getComputedStyle(document.body);
            const lightGrey = cs.getPropertyValue('--colour-brand-lightgrey');
            const darkGrey = cs.getPropertyValue('--colour-brand-darkgrey-2');
            const fontFamily = cs.getPropertyValue('--font-regular');
            if (this.occupationsGroupChart) {
                this.occupationsGroupChart.destroy();
            }

            this.occupationsGroupChart = new Chart(
                canvas, {
                type: 'bar',
                options: {
                    indexAxis: 'y',
                    scales: {
                        x: {
                            stacked: true,
                            ticks: {
                                font: {
                                    family: fontFamily,
                                    size: 12
                                },
                                color: lightGrey
                            },
                            grid: {
                                display: false,
                                color: lightGrey
                            }
                        },
                        y: {
                            stacked: true,
                            ticks: {
                                font: {
                                    family: fontFamily,
                                    size: 12
                                },
                                color: lightGrey
                            },
                            grid: {
                                color: darkGrey
                            }
                        }
                    },
                    plugins: {
                        legend: {
                            display: true,
                            labels: {
                                boxWidth: 12,
                                boxHeight: 12,
                                padding: 12,
                                color: lightGrey,
                                font: {
                                    family: fontFamily,
                                    size: 12
                                },
                            }
                        },
                        tooltip: {
                            color: lightGrey,
                            titleFont: {
                                family: fontFamily,
                                size: 12
                            },
                            bodyFont: {
                                family: fontFamily,
                                size: 12
                            },
                        }
                    },
                },
                data: {
                    labels: Object.keys(OccupationGroup).map(el => OccupationGroup[el].name),
                    datasets: this.formatOccupationGroupsChartData(occupationCountsByLocation)
                }
            });
        }

        formatOccupationGroupsChartData(occupationCountsByLocation) {
            // Split results into occupation groups
            return occupationCountsByLocation.map((element, index) => ({
                label: element.location,
                backgroundColor: ColorUtils.getColor(index),
                data: Object.keys(OccupationGroup).map(group => element[group])
            }));
        }

        createCompanyLocationsMap() {
            if (this.isFieldAvailable(this.locations) && document.getElementById("companyLocationsMap") == undefined) {
                const companyLocationMarkers = this.locations.reduce((accumulator, currentLocation) => {
                    let locationMarker = currentLocation.createLocationMapMarker(this.companyName);
                    if (locationMarker) {
                        accumulator.push(locationMarker);
                    }
                    return accumulator;
                }, []);
                if (companyLocationMarkers.length > 0) {
                    const companyLocationsMapHolder = document.getElementById("locationDataHolder").parentNode.appendChild(coreFunctions.createElementHelper("div", { class: "locations-map__holder company-locations-view", "data-view": "map-view" })); // Map hidden initially, table view is default
                    companyLocationsMapHolder.appendChild(coreFunctions.createElementHelper("div", { id: "companyLocationsMap" }));

                    this.companyLocationsMap = L.map("companyLocationsMap", {
                        zoomControl: false,
                        attributionControl: false,
                    }).setView([51.505, -0.09], 13);

                    L.control.zoom({
                        position: 'bottomright'
                    }).addTo(this.companyLocationsMap);

                    L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png', {
                        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
                        subdomains: 'abcd',
                        maxZoom: 19,
                        className: "LeafletTile"
                    }).addTo(this.companyLocationsMap);

                    this.companyLocationsFeatureGroup = L.featureGroup(companyLocationMarkers).addTo(this.companyLocationsMap);
                    this.resetCompanyLocationsMap();

                    let locationWithOccupationCounts;
                    // Add location details for the rest of world
                    if (this.occupationCountByNation && Object.hasOwn(this.occupationCountByNation, "ROW")) {
                        const restOfWorldBox = L.Control.extend({
                            options: {
                                position: 'topleft'
                            },
                            onAdd: (map) => this.occupationCountByNation.ROW.createOccupationCountsByNationDetails()
                        });
                        this.companyLocationsMap.addControl(new restOfWorldBox());

                    }
                    // Add general occupation groups key if no ROW data available
                    // else if ((locationWithOccupationCounts = this.locations.find(el => el.occupationCounts.countsAvailable())) != undefined) {
                    //     companyLocationsMapHolder.appendChild(locationWithOccupationCounts.occupationCounts.createOccupationCountsKey());
                    // }


                }
            }
        }

        resetCompanyLocationsMap() {
            this.companyLocationsMap.invalidateSize();
            // Adjust map view. Zoom out if too zoom level too close
            this.companyLocationsMap.fitBounds(this.companyLocationsFeatureGroup.getBounds());
            if (this.companyLocationsMap.getZoom() > 14) {
                this.companyLocationsMap.setView(this.companyLocationsMap.getCenter(), 14);
            }
        }

        addEsgDetailsToCompanyProfile() {
            if (this.isFieldAvailable(this.esgStatementAnchors)) {
                const esgStatementAnchors = this.esgStatementAnchors.sort((a, b) => a.word.localeCompare(b.word)); // Sort by word categories alphabetically
                const esgTableObject = {
                    elements: esgStatementAnchors,
                    tableHeadings: ["Description", "Link", "Category"],
                    tableElementsPerPage: 30
                }
                document.getElementById("sectionTabESG").parentElement.classList.remove("hidden");
                document.querySelector(".sectionBlock[data-section='ESG']").classList.remove("hidden");

                document.getElementById("esgDataHolder").appendChild(this.createDataFieldHolder("esgStatementAnchors", "ESG statement links", null, null)).appendChild(this.createExpandableTable(esgTableObject));
            }
            return this;
        }

        resultsSectionChange(element) {
            element.closest(".sectionTab").scrollIntoView({ block: "nearest", inline: "nearest" }); // Makes section tab fully on visible on mobile
            document.getElementById("sectionBlockHolder").dataset.currentsection = element.dataset.section;
            return this;
        }

        // Check this works for a company that doesn't have RTICs
        processCompanyProfileRtics(companyRtics) {
            const companyProfileObject = this;
            if (companyRtics != undefined) {
                companyRtics.forEach(vertical => companyProfileObject.newCompanyRtic(companyProfileObject.companyNumber, vertical.ParentName, vertical.RTICName));
            }
        }

        addWebsiteImage() {
            if (this.companyURL && this.companyURL.length) {
                let companyWebImage = new Image();
                // Image loaded successfully, add to page
                companyWebImage.onload = function () {
                    document.getElementById("companyWebImageHolder").appendChild(companyWebImage);
                };
                // Error loading the image, likely not available
                companyWebImage.onerror = function () {
                    console.log("Company image not found");
                    document.getElementById("companyWebImagePanel").remove();
                };
                companyWebImage.src = `https://tdcwebscreenshots.z35.web.core.windows.net/domainscreenshots/${this.companyURL[0]}/${this.companyURL}.png`;
            } else {
                document.getElementById("companyWebImagePanel").remove();
            }
            return this;
        }

        reportUrl(form) {
            let method, url, input, reportUrlSuccess, reportUrlError;
            method = "POST";
            url = `../api/company/company_actions.php?action=reporturl&company_number=${this.companyNumber}`;
            input = new FormData(form);

            reportUrlSuccess = function (response) {
                const responseParsed = JSON.parse(response);
                if (responseParsed && responseParsed.status == "success") {
                    document.querySelector(`.report_mismatched_url[data-companynumber='${responseParsed.company_number}']`).classList.add("reported");
                }
                coreFunctions.showStatusMessage(responseParsed.title, responseParsed.message);
                coreFunctions.hideOverlay(document.getElementById("reportMismatchedUrlButton"));
            }

            reportUrlError = function () {
                const response = {
                    status: "error",
                    title: "Submission error",
                    message: "Sorry, we could not submit your request at this time."
                }
                coreFunctions.showStatusMessage(response.title, response.message);
                coreFunctions.hideOverlay(document.getElementById("reportMismatchedUrlButton"));
            }

            coreFunctions.xhrHelper(method, url, reportUrlSuccess, reportUrlError, input);
        }

        setAllDownloadItems(state) {
            document.querySelectorAll('#downloadSelection input[name="downloadFields[]"]').forEach((node) => {
                node.checked = state;
            });
            document.querySelector('#downloadSelection input[name="downloadFields[]"][value="Companynumber"]').checked = true;
        }

        prepareCompanyProfileDownload(form) {
            const companyProfileObject = this;
            let method, url, input, prepareCompanyProfileDownloadSuccess, prepareCompanyProfileDownloadError;

            form.DownloadFields = Array.from(document.querySelectorAll('#downloadListOverlay input[name="downloadFields[]"]:checked'))
                .map((checkbox) => checkbox.value);
            form.DownloadFiles = Array.from(document.querySelectorAll('#downloadListOverlay input[name="downloadFiles[]"]:checked'))
                .map((checkbox) => checkbox.value);

            document.getElementById("downloadCompanyProfileButton").disabled = true;
            method = "POST";
            url = `../api/company/company_actions.php?action=preparedownload&company_number=${this.companyNumber}`;
            input = new FormData(form);

            document.getElementById('downloadSelection').classList.add('hidden');
            document.querySelector('#downloadListOverlay .overlayClose').classList.add('hidden');
            document.getElementById('downloadInProgress').classList.remove('hidden');

            prepareCompanyProfileDownloadSuccess = function (response) {
                const responseParsed = JSON.parse(response);
                coreFunctions.checkForDebugMessages(responseParsed);
                if (responseParsed && responseParsed.status == "success") {
                    companyProfileObject.downloadCompanyProfile(responseParsed.fileUrl)
                } else {
                    companyProfileObject.prepareCompanyProfileDownloadError(responseParsed.title, responseParsed.message);
                }

            }

            prepareCompanyProfileDownloadError = function () {
                companyProfileObject.prepareCompanyProfileDownloadError("Could not download company profile", "Sorry, an unexpected error occurred");
            }

            coreFunctions.xhrHelper(method, url, prepareCompanyProfileDownloadSuccess, prepareCompanyProfileDownloadError, input);
        }

        prepareCompanyProfileDownloadError(title, message) {
            document.getElementById("downloadCompanyProfileButton").disabled = false;
            coreFunctions.hideOverlay(document.getElementById("downloadCompanyProfileButton"));
            coreFunctions.showStatusMessage(title, message);
        }

        printProfile() {
            window.print();
            return this;
        }

        downloadCompanyProfile(fileUrl) {
            let filename, inputJSON, xhr;

            document.getElementById('downloadInProgress').classList.add('hidden');
            document.getElementById('downloadSelection').classList.remove('hidden');
            document.querySelector('#downloadListOverlay .overlayClose').classList.remove('hidden');
            document.getElementById("downloadListOverlay").classList.remove("downloadInProgress");
            document.getElementById("downloadCompanyProfileButton").disabled = false;

            filename = `Company_${this.companyNumber}_${fileUrl.replace(/\/.*\//, "")}`;
            inputJSON = {
                fileUrl: fileUrl
            }
            xhr = new XMLHttpRequest();
            xhr.open('POST', `../api/company/company_actions.php?action=downloadprofile&company_number=${this.companyNumber}`);
            xhr.responseType = 'blob';
            xhr.onload = function (e) {
                if (this.status == 200) {
                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveBlob(this.response, filename);
                    } else {
                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(this.response);
                        link.download = filename;
                        link.click();
                    }
                }
                coreFunctions.hideOverlay(document.getElementById("downloadCompanyProfileButton"));
            }
            xhr.send(JSON.stringify(inputJSON));
            return this;
        }

        toggleCompanyAlertSubscription() {
            const companyAlert = new CompanyAlert();
            if (document.getElementById("companyProfile-followCompanyControl").checked) {
                companyAlert.unsubscribeFromCompanyAlert(this.companyNumber, () => {
                    document.getElementById("companyProfile-followCompanyControl").checked = false;
                    document.querySelector(".listActionsControlHolder .company-alert span[data-follow='subscribe']").classList.remove("hidden");
                    document.querySelector(".listActionsControlHolder .company-alert span[data-unfollow='subscribed']").classList.add("hidden");
                });
            } else {
                companyAlert.subscribeToCompanyAlert(this.companyNumber, () => {
                    document.getElementById("companyProfile-followCompanyControl").checked = true;
                    document.querySelector(".listActionsControlHolder .company-alert span[data-follow='subscribe']").classList.add("hidden");
                    document.querySelector(".listActionsControlHolder .company-alert span[data-unfollow='subscribed']").classList.remove("hidden");
                }, (error) => {
                    document.getElementById("companyProfile-followCompanyControl").checked = false;
                });
            }
        }

        // Set element style class based on value
        getValueStyleClass(value) {
            let className = "";
            if (value < 0) {
                className = "orange";
            } else if (value > 0) {
                className = "green";
            }
            return className;
        }
    }

    return {
        companyProfile: companyProfile,
        pageBodyLoad: pageBodyLoad,
        showDetailedFinancials: showDetailedFinancials,
        navigateBack: navigateBack,
        toggleCompanyLocationsView: toggleCompanyLocationsView
    }
}();
